(function() {
    'use strict';
    /*
     * Copyright (c) 2016-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('IhhViewEditDateCtrl', IhhViewEditDateCtrl);

    IhhViewEditDateCtrl.$inject = ['$scope', '$filter', 'TimeSvc', 'CommonI18nService'];

    function IhhViewEditDateCtrl ($scope, $filter, TimeSvc, CommonI18nService) {
        /*jshint validthis: true */
        var vm = this;
        var dateFormat = 'yyyy-MM-dd';
        vm.today = TimeSvc.today;
        vm.tomorrow = TimeSvc.tomorrow;
        vm.i18n = CommonI18nService;

        // relate the directive strings with the datepicker date strings
        if (vm.maxDate === 'today') {
            vm.maxDateString = $filter('date')(vm.today(), dateFormat);
        }
        else if (vm.maxDate === 'tomorrow') {
            vm.maxDateString = $filter('date')(vm.tomorrow(), dateFormat);
        }

        if (vm.minDate === 'today') {
            vm.minDateString = $filter('date')(vm.today(), dateFormat);
        }
        else if (vm.minDate === 'tomorrow') {
            vm.minDateString = $filter('date')(vm.tomorrow(), dateFormat);
        }

        if (vm.initDate === 'tomorrow') {
            vm.initDateValue = vm.tomorrow();
        }
        else {
            vm.initDateValue = vm.today();
        }

        if (!vm.displayFormat) {
            vm.displayFormat = 'medium';
        }

        vm.toggleCalendar = function ($event, isCalendarOpen) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope[isCalendarOpen] = !$scope[isCalendarOpen];
            delete vm.timeEdit;
        };

        vm.timeChanged = function() {
            var modelAsDate = vm.modelEdit ? new Date(vm.modelEdit) : new Date();

            modelAsDate.setHours(vm.timeEdit.getHours());
            modelAsDate.setMinutes(vm.timeEdit.getMinutes());
            modelAsDate.setSeconds(vm.timeEdit.getSeconds());

            vm.modelEdit = modelAsDate;
        };

        vm.clearTime = function() {
            delete vm.modelEdit;
            delete vm.timeEdit;
        };
    }
})();